import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import urls from '@/constants/urls';
import DropdownSegment from '@/components/DropdownSegment';

const listItems = (intl, supportedTypes, value) => supportedTypes.map((type) => ({
  key: `datasource_type_dropdown_item_${type.code}`,
  text: intl.formatMessage({ id: `dataset.datasource.type.${type.code}` }),
  value: type.code,
  active: type.code === value,
  disabled: !type.enabled,
  description: type.enabled ? undefined : intl.formatMessage({ id: 'status.disabled' }),
}));

const description = (locked, supportedTypes, value) => {
  if (locked) return 'locked';
  const disabled = Object.values(supportedTypes).find((type) => type.code === value && !type.enabled);
  return disabled ? 'disabled' : value;
};

const DatasourceTypeDropdown = ({
  autoFocus,
  disabled,
  locked,
  onChange,
  supportedTypes,
  value,
  withDescription,
}) => {
  const intl = useIntl();
  return (
    <>
      <Dropdown
        autoFocus={autoFocus}
        className="aridhia-datasource-type-dropDown"
        disabled={locked || disabled}
        fluid
        id="datasource_type_dropdown"
        options={listItems(intl, supportedTypes, value)}
        onChange={onChange}
        placeholder={intl.formatMessage({ id: 'save.dataset.datasource.type.placeholder' })}
        selection
        value={value}
      />
      {withDescription && (
        <DropdownSegment
          className="aridhia-datasource-type-dropDown-description"
          messageText={intl.formatMessage(
            { id: `dataset.datasource.type.${description(locked, supportedTypes, value)}.description` },
            { kbLink: urls.KB, supportLink: urls.SERVICE_DESK, value },
          )}
          markdown
        />
      )}
    </>
  );
};

export default DatasourceTypeDropdown;
